<h2 mat-dialog-title>{{ data.isEdit ? 'Edit Recovery Agent' : 'New Recovery Agent' }}</h2>

<mat-dialog-content>
  <div *ngIf="dialogError" class="api-error-banner" style="margin-bottom: 15px;">{{ dialogError }}</div>
  <div class="api-error-banner" *ngIf="validationErrors.length > 0" style="margin-bottom: 15px;">
    <div>Please fix following errors:</div>
    <ul>
      <li *ngFor="let error of validationErrors">{{ error }}</li>
    </ul>
  </div>

  <div class="add-form-grid">
    <mat-form-field appearance="outline" floatLabel="always" class="recovery-field">
      <mat-label>Operating Company</mat-label>
      <input
        matInput
        type="text"
        placeholder="Select Operating Company"
        [formControl]="operatingCompanyControl"
        [matAutocomplete]="operatingCompanyAuto"
        [disabled]="data.isEdit"
        #operatingCompanyTrigger="matAutocompleteTrigger"
        (input)="onOperatingCompanyInput()"
      />
      <app-autocomplete-suffix-actions
        matSuffix
        [showClear]="!data.isEdit && operatingCompanyControl.value !== null && operatingCompanyControl.value !== ''"
        [toggleDisabled]="data.isEdit"
        [panelOpen]="operatingCompanyTrigger.panelOpen"
        (clearClicked)="clearOperatingCompany($event)"
        (toggleClicked)="openOrClosePanel($event, operatingCompanyTrigger)">
      </app-autocomplete-suffix-actions>
      <mat-autocomplete
        #operatingCompanyAuto="matAutocomplete"
        [clearStaleSelectionOnOpen]="operatingCompanyControl.value"
        [displayWith]="displayOperatingCompany"
        (optionSelected)="onOperatingCompanySelected($event.option.value)">
        <mat-option *ngFor="let option of filteredOperatingCompanyOptions$ | async" [value]="option">
          {{ option.label }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" class="recovery-field">
      <mat-label>Office Key</mat-label>
      <input
        matInput
        type="text"
        [formControl]="officeKeyControl"
        [matAutocomplete]="officeKeyAuto"
        [disabled]="data.isEdit"
        #officeKeyTrigger="matAutocompleteTrigger"
        (input)="onOfficeKeyInput()"
      />
      <app-autocomplete-suffix-actions
        matSuffix
        [showClear]="!data.isEdit && officeKeyControl.value !== null && officeKeyControl.value !== ''"
        [toggleDisabled]="data.isEdit"
        [panelOpen]="officeKeyTrigger.panelOpen"
        (clearClicked)="clearOfficeKey($event)"
        (toggleClicked)="openOrClosePanel($event, officeKeyTrigger)">
      </app-autocomplete-suffix-actions>
      <mat-autocomplete
        #officeKeyAuto="matAutocomplete"
        [clearStaleSelectionOnOpen]="officeKeyControl.value"
        [displayWith]="displayOfficeKey"
        (optionSelected)="onOfficeKeySelected($event.option.value)">
        <mat-option *ngFor="let option of filteredOfficeKeyOptions$ | async" [value]="option">
          {{ option.label }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" class="recovery-field">
      <mat-label>RA Mailing Name</mat-label>
      <input matInput [(ngModel)]="formRecord.RAMailingName" required type="text" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="recovery-field">
      <mat-label>Street1</mat-label>
      <input matInput [(ngModel)]="formRecord.Street1" required type="text" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="recovery-field">
      <mat-label>Street2</mat-label>
      <input matInput [(ngModel)]="formRecord.Street2" type="text" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="recovery-field">
      <mat-label>City</mat-label>
      <input matInput [(ngModel)]="formRecord.City" required type="text" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="recovery-field">
      <mat-label>State</mat-label>
      <input
        matInput
        type="text"
        [formControl]="stateControl"
        [matAutocomplete]="stateAuto"
        #stateTrigger="matAutocompleteTrigger"
        (input)="onStateInput()"
        required
      />
      <app-autocomplete-suffix-actions
        matSuffix
        [showClear]="stateControl.value !== null && stateControl.value !== ''"
        [panelOpen]="stateTrigger.panelOpen"
        (clearClicked)="clearState($event)"
        (toggleClicked)="openOrClosePanel($event, stateTrigger)">
      </app-autocomplete-suffix-actions>
      <mat-autocomplete
        #stateAuto="matAutocomplete"
        [clearStaleSelectionOnOpen]="stateControl.value"
        [displayWith]="displayState"
        (optionSelected)="onStateSelected($event.option.value)">
        <mat-option *ngFor="let state of filteredStateOptions$ | async" [value]="state">{{ state.label }}</mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" class="recovery-field">
      <mat-label>ZipCode</mat-label>
      <input
        matInput
        [(ngModel)]="formRecord.ZipCode" required
        (input)="onZipInput('ZipCode', 5)"
        type="text"
        inputmode="numeric"
        maxlength="5"
      />
    </mat-form-field>

    <mat-form-field appearance="outline" class="recovery-field">
      <mat-label>Zip Plus4</mat-label>
      <input
        matInput
        [(ngModel)]="formRecord.ZipPlus4"
        (input)="onZipInput('ZipPlus4', 4)"
        type="text"
        inputmode="numeric"
        maxlength="4"
      />
    </mat-form-field>

    <mat-form-field appearance="outline" class="recovery-field">
      <mat-label>Tax ID</mat-label>
      <input
        matInput
        [(ngModel)]="formRecord.RecoveryAgentTaxID"
        (keydown.space)="$event.preventDefault()"
        type="text"
        inputmode="numeric"
        maxlength="9"
        [disabled]="formRecord.ExternalOrg === 'NO'"
      />
    </mat-form-field>

    <mat-form-field appearance="outline" class="recovery-field">
      <mat-label>Is External Organization</mat-label>
      <input
        matInput
        type="text"
        [formControl]="externalOrgControl"
        [matAutocomplete]="externalOrgAuto"
        #externalOrgTrigger="matAutocompleteTrigger"
        (input)="onExternalOrgInput()"
      />
      <app-autocomplete-suffix-actions
        matSuffix
        [showClear]="false"
        [panelOpen]="externalOrgTrigger.panelOpen"
        (toggleClicked)="openOrClosePanel($event, externalOrgTrigger)">
      </app-autocomplete-suffix-actions>
      <mat-autocomplete
        #externalOrgAuto="matAutocomplete"
        [clearStaleSelectionOnOpen]="externalOrgControl.value"
        [displayWith]="displayExternalOrg"
        (optionSelected)="onExternalOrgSelected($event.option.value)">
        <mat-option *ngFor="let option of filteredExternalOrgOptions$ | async" [value]="option">
          {{ option.label }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" class="recovery-field">
      <mat-label>Paperless Indicator</mat-label>
      <input
        matInput
        type="text"
        [formControl]="paperlessIndicatorControl"
        [matAutocomplete]="paperlessIndicatorAuto"
        #paperlessIndicatorTrigger="matAutocompleteTrigger"
        (input)="onPaperlessIndicatorInput()"
      />
      <app-autocomplete-suffix-actions
        matSuffix
        [showClear]="paperlessIndicatorControl.value !== null && paperlessIndicatorControl.value !== ''"
        [panelOpen]="paperlessIndicatorTrigger.panelOpen"
        (clearClicked)="clearPaperlessIndicator($event)"
        (toggleClicked)="openOrClosePanel($event, paperlessIndicatorTrigger)">
      </app-autocomplete-suffix-actions>
      <mat-autocomplete
        #paperlessIndicatorAuto="matAutocomplete"
        [clearStaleSelectionOnOpen]="paperlessIndicatorControl.value"
        [displayWith]="displayPaperlessIndicator"
        (optionSelected)="onPaperlessIndicatorSelected($event.option.value)">
        <mat-option *ngFor="let option of filteredPaperlessIndicatorOptions$ | async" [value]="option">
          {{ option.label }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" type="button" (click)="onSubmit()">
    {{ data.isEdit ? 'Update' : 'Submit' }}
  </button>
  <button mat-stroked-button type="button" (click)="onCancel()">
    Cancel
  </button>
</mat-dialog-actions>
